import React, { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { VIDEO } from "@/constants/testIds";
import { SITE, MEDIA } from "@/lib/site";

export const VideoShowcase = () => {
  const [playing, setPlaying] = useState(false);

  return (
    <section
      id="showreel"
      data-testid={VIDEO.root}
      className="relative py-28 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="max-w-3xl mb-12">
          <div className="inline-flex items-center gap-2 rounded-full glass px-4 py-2 text-xs uppercase tracking-[0.2em] text-white/70">
            Showreel 2025
          </div>
          <h2 className="font-display mt-6 text-4xl md:text-5xl lg:text-6xl font-light tracking-tight">
            Notre <span className="italic font-semibold">signature</span>,
            <br />en mouvement.
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.9 }}
          className="relative aspect-video rounded-3xl overflow-hidden glass-strong"
        >
          {!playing ? (
            <button
              onClick={() => setPlaying(true)}
              className="group absolute inset-0 z-10"
              aria-label="Lire la vidéo"
            >
              <img
                src={MEDIA.particles}
                alt=""
                className="h-full w-full object-cover opacity-70 group-hover:opacity-100 transition"
              />
              <div className="absolute inset-0 bg-black/35" />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="relative inline-flex h-24 w-24 items-center justify-center rounded-full bg-[#007AFF] text-white shadow-[0_0_60px_rgba(0,122,255,0.55)] group-hover:scale-110 transition">
                  <span className="absolute inset-0 rounded-full bg-[#007AFF] animate-ping opacity-30" />
                  <Play size={32} className="relative ml-1" fill="currentColor" />
                </span>
              </div>
            </button>
          ) : (
            <iframe
              data-testid={VIDEO.iframe}
              src={`https://www.youtube.com/embed/${SITE.primaryYoutubeId}?autoplay=1&rel=0&modestbranding=1`}
              title="Spectacle drones3x.fr"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="absolute inset-0 h-full w-full"
            />
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default VideoShowcase;
